<template>
  <AdvertisementForm 
    mode="convert" 
    :loading="loading" 
    :initialData="advertisementData"
    @submit="handleConvert"
    @cancel="$router.push({ name: 'superadmin-tools-advertisement-detail' })"
  />
  
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4"><div class="font-medium">{{ $t('advertisement.edited') }}!</div></div>
  </div>
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4"><div class="font-medium">{{ $t('advertisement.notEdited') }}!</div></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Toastify from 'toastify-js'
import advertisementApi from '@/services/advertisement/advertisement.api'
import AdvertisementForm from '@/components/advertisement/AdvertisementForm.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const advertisementData = ref(null)

onMounted(async () => {
  try {
    const response = await advertisementApi.getDetail(route.params.uuid)
    advertisementData.value = response.data
    loading.value = false
  } catch (error) {
    console.error(error)
    router.push({ name: 'superadmin-tools-advertisement' })
  }
})

const handleConvert = async (payload) => {
  if(!payload.businessId && advertisementData.value.businessId) {
    payload.businessId = advertisementData.value.businessId
  }

  try {
    await advertisementApi.convertAdvertisement(advertisementData.value.branch.uuid, payload)
    Toastify({
      node: cash('#success-notification-content').clone().removeClass('hidden')[0],
      duration: 5000, newWindow: true, close: true, gravity: 'top', position: 'right', stopOnFocus: true
    }).showToast()
    router.push({ name: 'superadmin-tools-advertisement' })
  } catch (error) {
    console.error(error)
    Toastify({
      node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
      duration: 10000, newWindow: true, close: true, gravity: 'top', position: 'right', stopOnFocus: true
    }).showToast()
  }
}
</script>